<div nz-row>
  <div class="labs-dashboard-container">
    <div nz-col [nzSpan]="24">
      <div class="dashboard-leftpannle" nz-col [nzSpan]="6">
        <div class="container">
          <div class="margin_bottom_10" nz-row>
            <div class="heading">
              Your Access
            </div>
          </div>
          <div class="margin_bottom_15" nz-row>
            <label class="font_12">
              Your firm doesn’t currently have access to Labs. Contact us for
              access:
            </label>
          </div>
          <div class="margin_bottom_15" nz-row>
            <button (click)="sendRequest.emit('Test data')" class="btn">
              Request Accesss
            </button>
          </div>
        </div>
      </div>

      <div class="dashboard-rightpannle" nz-col [nzSpan]="18">
        <div class="container">
          <div class="margin_bottom_10" nz-row>
            <div class="heading">
              About VA Labs
            </div>
          </div>
          <div class="margin_bottom_15" nz-row>
            <label class="font_12">
              VA Labs is a new experimental platform within Visible Alpha
              Insights that allows us to offer powerful new ways of viewing our
              unique content.
            </label>
          </div>
          <div class="margin_bottom_15" nz-row>
            <label class="font_12">
              We’re developing new reports all the time and excited to hear your
              feedback on all aspects of VA Labs.
            </label>
          </div>
          <div class="margin_bottom_15" nz-row>
            <label class="font_12">
              If you have questions, please contact
            </label>
          </div>
          <div class="margin_bottom_15" nz-row>
            <label class="font_12">
              If you have questions, please contact
              <a href="mailto:support@visiblealpha.com"
                >support@visiblealpha.com</a
              >
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
